import { AditionInitialization } from '@components/atoms/Adition/AditionInitialization';
import { Oewa } from '@components/atoms/Oewa/Oewa';
import { Title } from '@components/atoms/Title';
import { Article } from '@components/templates/layouts/Article';
import { adPositions } from '@lib/adition/adPositions';
import { prerenderPaths } from '@lib/graphql/helpers/prerenderPaths';
import { AditionTagPlacement } from '@vgn-medien-holding/vgn-fe-components';
import Head from 'next/head';
import type { GetStaticPaths } from 'next/types';

function Adventkalender() {
  const data = {
    siteBar: true,
    article: true,
    slug: 'adventkalender',
  };

  return (
    <div>
      <AditionInitialization tags={adPositions} data={data} fixedPageType={'adventkalender'} />
      <Oewa pageKey={'UnterhaltungGames'} categoryKey={'Games'} profileKey={'Gewinnspiele'} />
      <Head>
        <title>TV-Media Adventkalender</title>
      </Head>
      <div className="relative -mb-40 bg-white px-4 pt-8 sm:px-8 md:px-16 md:pt-16">
        <div
          className={'-mt-16 -ml-16 hidden md:absolute md:block'}
          style={{
            backgroundImage: `url(/assets/advent_calendar/bg_advent_desktop.png)`,
            width: '100%',
            height: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'left top',
          }}
        />
        <div
          className={'-mt-8 -ml-8 hidden sm:absolute sm:block md:hidden'}
          style={{
            backgroundImage: `url(/assets/advent_calendar/bg_advent_tablet.png)`,
            width: '100%',
            height: '100%',
            backgroundRepeat: 'repeat',
            backgroundPosition: 'top',
          }}
        />
        <div
          className={'absolute -mt-8 -ml-4 sm:hidden'}
          style={{
            backgroundImage: `url(/assets/advent_calendar/bg_advent_desktop.png)`,
            width: '100%',
            height: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'left top',
          }}
        />
        <div className={'prose relative flex flex-col content-center text-center text-black lg:text-start'}>
          <div className={'mt-48 flex w-full max-w-[980px] flex-col rounded-4xl bg-white p-4'}>
            <Title level={1} classProps={{ heading: 'text-black z-10 ' }}>
              TV-MEDIA Adventkalender
            </Title>
            <span className={'z-10 py-1.5 text-2xl'}>
              Mit TV-MEDIA die besinnlichste Zeit des Jahres feiern und jeden Tag tolle Geschenke gewinnen: Jetzt 24
              Türchen von unserem Adventkalender öffnen und jeden Tag eine neue Chance auf grandiose Preise haben! Wir
              wünschen frohe Weihnachten!
            </span>
          </div>
          <div className={'flex w-full flex-col xl:flex-row'}>
            <AditionTagPlacement
              tag={adPositions[35]}
              tagCount={0}
              classProps={{ root: 'xl:hidden grid place-items-center m-auto p-3 relative' }}
            />
            {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
            <div id="qualifio_insert_place_1307411" className="qualifio_iframe_wrapper w-full max-w-[980px]">
              <iframe
                src="https://vgnat.qualifioapp.com/20/3D60273B-4B4B-4C0F-81BC-CA08B2999BCF/v1.cfm?id=3D60273B-4B4B-4C0F-81BC-CA08B2999BCF"
                id="qualifio1307411"
                title="qualifio"
                // eslint-disable-next-line tailwindcss/no-custom-classname
                className="qualifio_iframe_tag mb-20 rounded-4xl xl:h-[1886px]"
                width="100%"
                height={2200}
                scrolling="auto"
                frameBorder={0}
                style={{ overflowX: 'hidden', maxWidth: 1080 }}
              />
            </div>
            <AditionTagPlacement
              tag={adPositions[35]}
              tagCount={1}
              classProps={{ root: 'xl:hidden grid place-items-center m-auto p-3 mb-20 relative' }}
            />
            <AditionTagPlacement
              tag={adPositions[34]}
              classProps={{ root: 'sticky top-28 mb-20 h-[600px] w-[300px] hidden xl:block' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: await prerenderPaths(['/adventkalender/index']),
    fallback: 'blocking',
  };
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

Adventkalender.PageLayout = Article;

export default Adventkalender;
